import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { ButtonModule } from './../button/button.module';
import { ResourceCarouselSlideDirective } from './resource-carousel-slide.directive';
import { ResourceCarouselComponent } from './resource-carousel.component';
import { CarouselModule } from '../carousel';

@NgModule({
  imports: [CommonModule, MatIconModule, ButtonModule, CarouselModule],
  declarations: [ResourceCarouselComponent],
  exports: [ResourceCarouselComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ResourceCarouselModule {}
